import { Cloud, Server, Cpu } from "lucide-react";

// Single source of truth for provider metadata and model catalogs.
// Used by SettingsDialog (full provider config) and ChatArea (quick model switcher).
export const PROVIDERS = {
  anthropic: {
    name: "Anthropic",
    icon: Cloud,
    requiresKey: true,
    keyUrl: "https://console.anthropic.com/settings/keys",
    keyPrefix: "sk-ant-",
    models: [
      { value: "claude-opus-4-8", label: "Claude Opus 4.8" },
      { value: "claude-sonnet-5", label: "Claude Sonnet 5" },
      { value: "claude-haiku-4-5", label: "Claude Haiku 4.5" },
    ]
  },
  openai: {
    name: "OpenAI",
    icon: Cloud,
    requiresKey: true,
    keyUrl: "https://platform.openai.com/api-keys",
    keyPrefix: "sk-",
    models: [
      { value: "gpt-5.2", label: "GPT-5.2" },
      { value: "gpt-4o", label: "GPT-4o" },
      { value: "gpt-4o-mini", label: "GPT-4o Mini" },
    ]
  },
  gemini: {
    name: "Google Gemini",
    icon: Cloud,
    requiresKey: true,
    keyUrl: "https://aistudio.google.com/app/apikey",
    keyPrefix: "AI",
    models: [
      { value: "gemini-3-flash-preview", label: "Gemini 3 Flash" },
      { value: "gemini-3-pro-preview", label: "Gemini 3 Pro" },
    ]
  },
  deepseek: {
    name: "Deepseek",
    icon: Cloud,
    requiresKey: true,
    keyUrl: "https://platform.deepseek.com/api_keys",
    keyPrefix: "sk-",
    models: [
      { value: "deepseek-chat", label: "Deepseek Chat V3" },
      { value: "deepseek-reasoner", label: "Deepseek Reasoner R1" },
    ]
  },
  groq: {
    name: "Groq (Free)",
    icon: Cloud,
    requiresKey: true,
    keyUrl: "https://console.groq.com/keys",
    keyPrefix: "gsk_",
    models: [
      { value: "llama-3.3-70b-versatile", label: "Llama 3.3 70B" },
      { value: "llama-3.1-8b-instant", label: "Llama 3.1 8B" },
      { value: "mixtral-8x7b-32768", label: "Mixtral 8x7B" },
      { value: "gemma2-9b-it", label: "Gemma 2 9B" },
    ]
  },
  eugpt: {
    name: "EuGPT",
    icon: Cloud,
    requiresKey: true,
    keyUrl: "https://eugpt.ai/api",
    keyPrefix: "eugpt-",
    models: [
      { value: "eugpt-1", label: "EuGPT 1" },
    ]
  },
  openrouter: {
    name: "OpenRouter",
    icon: Server,
    requiresKey: true,
    keyUrl: "https://openrouter.ai/keys",
    keyPrefix: "sk-or-",
    models: [
      { value: "anthropic/claude-3.5-sonnet", label: "Claude 3.5 Sonnet" },
      { value: "anthropic/claude-3.5-haiku", label: "Claude 3.5 Haiku" },
      { value: "openai/gpt-4o", label: "GPT-4o" },
      { value: "openai/gpt-4o-mini", label: "GPT-4o Mini" },
      { value: "google/gemini-pro-1.5", label: "Gemini Pro 1.5" },
      { value: "deepseek/deepseek-chat", label: "Deepseek V3" },
      { value: "deepseek/deepseek-r1", label: "Deepseek R1" },
      { value: "meta-llama/llama-3.3-70b-instruct", label: "Llama 3.3 70B" },
      { value: "mistralai/mistral-large", label: "Mistral Large" },
      { value: "qwen/qwen-2.5-72b-instruct", label: "Qwen 2.5 72B" },
    ]
  },
  // CC3 (besluit Frank 24 oktober 2026): een eigen OpenAI-compatibele aanbieder, met een
  // adres en een sleutel die Frank zelf invult. Het model is vrij in te vullen, en de plek is
  // onbekend tot hij hem zet (`aanbieder-locatie.locatieVan`).
  eigen: {
    name: "Eigen aanbieder (OpenAI-compatibel)",
    icon: Server,
    requiresKey: true,
    keyUrl: "",
    keyPrefix: "",
    vrijModel: true,
    models: [],
  },
  ollama: {
    name: "Ollama (Local)",
    icon: Cpu,
    requiresKey: false,
    models: [] // populated dynamically from the user's local Ollama instance
  }
};

export function findModelLabel(provider, modelValue) {
  const entry = PROVIDERS[provider]?.models.find(m => m.value === modelValue);
  return entry?.label || modelValue;
}
